/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_SaturdayInputs */

const en_coach_day_saturday = /** @type {(inputs: Coach_Day_SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

const de_coach_day_saturday = /** @type {(inputs: Coach_Day_SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samstag`)
};

/**
* | output |
* | --- |
* | "Saturday" |
*
* @param {Coach_Day_SaturdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_saturday = /** @type {((inputs?: Coach_Day_SaturdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_SaturdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_saturday(inputs)
	return de_coach_day_saturday(inputs)
});